<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/m2-header.png')"
          class="my-3"
          contain
          height="250"
        />
      </v-col>
    </v-row>

    <v-row class="text-center mt-4 mb-4">
      <v-col md="10" offset-md="1">
        <h3 class="roboto-text ma-2 font-weight-regular">
          Thank you for participating! Winners will be notified by email. And remember to follow us on social media to stay up to date with all the latest news from the M2 World Championship.
        </h3>
        <h3 class="roboto-text ma-2 font-weight-thin">
        Terima kasih telah berpartisipasi! Pemenang akan dihubungi lewat email. Jangan lupa untuk mengikuti akun media sosial kami untuk mendapatkan kabar terkini dari M2 World Championship.
        </h3>
      </v-col>
    </v-row>


     <v-row class="text-center mt-4 mb-4">
      <v-col md="10" offset-md="1">
        <p class="roboto-text ma-4  body-1
font-weight-regular">
          Think you can do better than your friends? Prove it by inviting them to play Predict the Winners here:
        </p>
        <p class="roboto-text ma-4 body-1
font-weight-thin">
        Merasa lebih jago dari teman Anda? Buktikan dengan mengundang mereka bermain Predict the Winners di sini:
        </p>
    <v-btn class="ma-2" dark fab bottom color="tertiary"  :href="`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`" target="_blank">
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
        <v-btn class="ma-2" dark fab bottom color="tertiary"  :href="`https://www.twitter.com/share?text=${shareMsg}&url=${pageUrl}`" target="_blank">
          <v-icon>mdi-twitter</v-icon>
        </v-btn>
        <v-btn class="ma-2" dark fab bottom color="tertiary"  :href="`https://wa.me/?text=${shareMsg}.%20${pageUrl}`" target="_blank">
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
        <v-btn class="ma-2" dark fab bottom color="tertiary"  :href="`mailto:?subject=Awesomeness!&amp;body=${shareMsg}<a href='${pageUrl}'>${pageUrl}</a>`" target="_blank">
          <v-icon>mdi-email</v-icon>
        </v-btn>
 </v-col>
    </v-row>    

    <v-row class="text-center mt-4 mb-4">
      <v-col md="8" offset-md="2">
       <v-btn
       class="submission"
      depressed
      dark
      large
      width="230px"
      color="purple"
      @click="reloadPage()"
      target="_blank"
    >
          <span>Back to ONEEsports</span>
        </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>


<script>

export default {
  name: "ThankYou",
  data() {
    return {
      dialShare: false,
      pageUrl: "https://www.oneesports.gg/m2predict/",
      shareMsg: "Think you can do better than your friends? Prove it by inviting them to play Predict the Winners here"
    }
  },
  methods: {
    reloadPage() {
      window.open("https://oneesports.gg");
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');

.roboto-text {
    font-family: 'Roboto', sans-serif;
}
.submission {
    background-color: white;
}
.v-messages__message {
  font-size: 14px;
}
.v-text-field {
  width: 400px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.item-color {
  background-color: grey;
  text-align: center;
  padding: 4px;
  width: 300px;
  height: 40px;
  margin-top: 10px;
  opacity: 70%;
  color: white;
}
.team-img {
  text-align: left;
}
</style>


